module.exports = __webpack_public_path__ + "img/caseBuilder-banking.370d3e4c.webp";